export default __webpack_public_path__ + "static/media/no-search-result-icon.f78cf2ed.svg";